// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn1 {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn1:hover {
  color: white;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn2 {
  color: #fff;
  background-color: #b30b00;
  border-color: transparent;
  border-radius: 10%;
  float: left !important;
  height: 37px;
}
.btn2:hover {
  color: white;
}
@media (min-width: 864px) and (max-width: 900px) {
  .btn2 {
    color: #fff;
    background-color: #b30b00;
    border-color: transparent;
    border-radius: 10%;
    float: left !important;
    height: 37px;
    margin: 0 0 0 -86px;
  }
}
@media (min-width: 100px) and (max-width: 850px) {
  .btn2 {
    color: #fff;
    background-color: #b30b00;
    border-color: transparent;
    border-radius: 10%;
    float: left !important;
    height: 37px;
  }
  .btn1 {
    color: white;
    background-color: #6c757d;
    border-color: #6c757d;
    float: left !important;
  }
}
@media (min-width: 901px) and (max-width: 1300px) {
  .btn2 {
    color: #fff;
    background-color: #b30b00;
    border-color: transparent;
    border-radius: 10%;

    height: 37px;
  }
}
.table-container {
  position: relative;
}
.table-container .pagination {
  position: absolute;
  right: 0;
  padding-right: 8px;
}

.pagination a {
  color: black;
  padding: 8px 16px;
  text-decoration: none;
}
.pagination a:hover {
  color: black;
}

.page-item.active .page-link {
  background-color: #343a40;
  border-color: #343a40;
  text-decoration: none;
}

.page-link:focus {
  box-shadow: none;
}
.pagination {
  float: right;
}
`, "",{"version":3,"sources":["webpack://./src/utils/Css/employeelist.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;EACrB;AACF;AACA;EACE;IACE,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;AACA;EACE;IACE,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;;IAElB,YAAY;EACd;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd","sourcesContent":[".btn1 {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn1:hover {\n  color: white;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn2 {\n  color: #fff;\n  background-color: #b30b00;\n  border-color: transparent;\n  border-radius: 10%;\n  float: left !important;\n  height: 37px;\n}\n.btn2:hover {\n  color: white;\n}\n@media (min-width: 864px) and (max-width: 900px) {\n  .btn2 {\n    color: #fff;\n    background-color: #b30b00;\n    border-color: transparent;\n    border-radius: 10%;\n    float: left !important;\n    height: 37px;\n    margin: 0 0 0 -86px;\n  }\n}\n@media (min-width: 100px) and (max-width: 850px) {\n  .btn2 {\n    color: #fff;\n    background-color: #b30b00;\n    border-color: transparent;\n    border-radius: 10%;\n    float: left !important;\n    height: 37px;\n  }\n  .btn1 {\n    color: white;\n    background-color: #6c757d;\n    border-color: #6c757d;\n    float: left !important;\n  }\n}\n@media (min-width: 901px) and (max-width: 1300px) {\n  .btn2 {\n    color: #fff;\n    background-color: #b30b00;\n    border-color: transparent;\n    border-radius: 10%;\n\n    height: 37px;\n  }\n}\n.table-container {\n  position: relative;\n}\n.table-container .pagination {\n  position: absolute;\n  right: 0;\n  padding-right: 8px;\n}\n\n.pagination a {\n  color: black;\n  padding: 8px 16px;\n  text-decoration: none;\n}\n.pagination a:hover {\n  color: black;\n}\n\n.page-item.active .page-link {\n  background-color: #343a40;\n  border-color: #343a40;\n  text-decoration: none;\n}\n\n.page-link:focus {\n  box-shadow: none;\n}\n.pagination {\n  float: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
